import type {
  InventorySystemProfileDTO,
  VenueInventorySystemProfileLink,
} from '../../../types'

export function buildVenueInventorySystemProfileLinks(
  selectedIds: readonly string[],
  profiles: readonly InventorySystemProfileDTO[]
): VenueInventorySystemProfileLink[] {
  const profileById = new Map(profiles.map((profile) => [profile.id, profile]))
  return selectedIds.flatMap((id) => {
    const profile = profileById.get(id)
    if (!profile) {
      return []
    }
    return [
      {
        inventorySystemProfileId: Number(profile.id),
        tenantGroupId: Number(profile.tenantGroupId),
      },
    ]
  })
}
